import React, { useEffect, useState } from 'react'
import ODCCUtilizationPage from '../../../ODCCUtilization'
import { useSelector } from 'react-redux';
import { odccUtilizationTxn } from '../../../../../api/commonApis';

const ODCCUtilization = () => {

  const { reportDetails, selectedAccountId } = useSelector(({ reportDetails }) => reportDetails);
  const [odcc, setOdcc] = useState([]);

  useEffect(() => {

      const fetchData = async () => {
        try {
          let aggregate = selectedAccountId !== 'all'? false : true;
          let account_id = selectedAccountId !== 'all'? selectedAccountId : reportDetails?.report?.reportId;
          const response = await odccUtilizationTxn(account_id, aggregate);
  
          if(Object.keys(response).length > 0){
            setOdcc(response)
          } else{
            setOdcc([])
          }
  
        } catch (error) {
          console.log("ERROR", error);
        }
      }
  
      if (selectedAccountId) fetchData();
    }, [selectedAccountId]);

  return (
    <ODCCUtilizationPage odcc={odcc} />
  )
}

export default ODCCUtilization